import { Link } from 'react-router-dom';
import { PageTransition, FadeIn } from '../components/layout';
import { ChevronRight } from 'lucide-react';

export default function CGVPage() {
  return (
    <PageTransition>
      <section className="pt-32 pb-8 px-6 bg-gradient-to-b from-[var(--champagne)]/30 to-white">
        <div className="max-w-[800px] mx-auto text-center">
          <h1 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light mb-4 text-[var(--charcoal)]">
            Conditions Générales de Vente
          </h1>
        </div>
      </section>

      <div className="bg-white py-4 border-b border-[var(--champagne)]">
        <div className="max-w-[1400px] mx-auto px-6">
          <nav className="flex items-center gap-2 text-sm text-[var(--charcoal)]/60">
            <Link to="/" className="hover:text-[var(--gold)] transition-colors">Accueil</Link>
            <ChevronRight size={14} />
            <span className="text-[var(--charcoal)]">CGV</span>
          </nav>
        </div>
      </div>

      <section className="py-16 px-6" data-testid="cgv-content">
        <div className="max-w-[800px] mx-auto">
          <FadeIn>
            <div className="prose prose-lg max-w-none text-[var(--charcoal)]/70">
              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mb-4">Article 1 - Objet</h2>
              <p>
                Les présentes conditions générales de vente régissent les ventes de produits Press On Nails 
                effectuées sur le site dsrs.com.
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Article 2 - Prix</h2>
              <p>
                Les prix sont indiqués en euros TTC. Ils sont susceptibles d'être modifiés à tout moment. 
                Le prix applicable est celui affiché au moment de la commande.
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Article 3 - Commande</h2>
              <p>
                Les Press On Nails sont fabriqués sur mesure. Un délai de 5 à 7 jours ouvrés est nécessaire 
                pour la fabrication. Le paiement est requis à la commande.
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Article 4 - Livraison</h2>
              <p>
                La livraison est effectuée en point relais ou à domicile. 
                Les délais de livraison sont indicatifs et ne peuvent engager notre responsabilité.
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Article 5 - Rétractation</h2>
              <p>
                Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation 
                ne s'applique pas aux produits personnalisés ou fabriqués sur mesure.
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Article 6 - Réclamations</h2>
              <p>
                Toute réclamation doit être adressée par email à contact@madamedsrs.fr dans les 48h suivant la réception.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>
    </PageTransition>
  );
}
